import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledChangeToPrescriptionForYearLink = styled(Link)`
   font-size: inherit;
   line-height: inherit;
`;

StyledChangeToPrescriptionForYearLink.displayName = 'StyledChangeToPrescriptionForYearLink';
